export default "__VITE_ASSET__DtatVVSX__"